var _path;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconBCalendar(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    xmlnsserif: "http://www.serif.com/",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    id: "iconB-calendar",
    x: 0,
    y: 0,
    width: 24,
    height: 24,
    style: {
      fill: "none"
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7,3.005l0,-1.005c-0,-0.552 0.448,-1 1,-1c0.552,-0 1,0.448 1,1l0,1l6,0l0,-1c0,-0.552 0.448,-1 1,-1c0.552,0 1,0.448 1,1l0,1.005c1.406,0.02 2.19,0.112 2.816,0.431c0.753,0.383 1.365,0.995 1.748,1.748c0.375,0.735 0.436,1.691 0.436,3.616l0,7.4c0,1.925 -0.061,2.881 -0.436,3.616c-0.383,0.753 -0.995,1.365 -1.748,1.748c-0.735,0.375 -1.691,0.436 -3.616,0.436l-8.4,-0c-1.925,0 -2.881,-0.061 -3.616,-0.436c-0.753,-0.383 -1.365,-0.995 -1.748,-1.748c-0.375,-0.735 -0.436,-1.691 -0.436,-3.616l0,-7.4c0,-1.925 0.061,-2.881 0.436,-3.616c0.383,-0.753 0.995,-1.365 1.748,-1.748c0.626,-0.319 1.411,-0.411 2.816,-0.431Zm-3,5.995l16,-0l0,-0.2c0,-1.436 0.061,-2.16 -0.218,-2.708c-0.192,-0.376 -0.498,-0.682 -0.874,-0.874c-0.436,-0.222 -0.982,-0.229 -1.908,-0.222l0,1.004c0,0.552 -0.448,1 -1,1c-0.552,0 -1,-0.448 -1,-1l0,-1l-6,-0l0,1c-0,0.552 -0.448,1 -1,1c-0.552,-0 -1,-0.448 -1,-1l0,-1.004c-0.926,-0.007 -1.472,-0 -1.908,0.222c-0.376,0.192 -0.682,0.498 -0.874,0.874c-0.279,0.548 -0.218,1.272 -0.218,2.708l0,0.2Zm16,2l-16,-0l0,5.2c0,1.436 -0.061,2.159 0.218,2.708c0.192,0.376 0.498,0.682 0.874,0.874c0.548,0.279 1.272,0.218 2.708,0.218l8.4,0c1.436,0 2.16,0.061 2.708,-0.218c0.376,-0.192 0.682,-0.498 0.874,-0.874c0.279,-0.548 0.218,-1.272 0.218,-2.708l0,-5.2Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBCalendar);
export default __webpack_public_path__ + "static/media/iconB-calendar.6f2e294ede90b2b080a0990ed771698d.svg";
export { ForwardRef as ReactComponent };